import { Login } from '@/features/auth/components/Login';

export const LoginPage = () => <Login />;
